<template>
  <a class="icon" :href="url" v-if="url">
    <i class="fa fa-info-circle"/>
  </a>
  <span class="icon" v-else-if="description" @click="showDescription">
    <i class="fa fa-info-circle"/>
  </span>
</template>

<script>
export default {
  props: {
    url: {type: String, default: null},
    description: {type: String, default: null}
  },

  methods: {
    showDescription(){
      this.$dialog.alert({
        message: this.description.replace(/\n/g, '<br/>'),
        confirmText: this.$t('Thank you')
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/InfoMessage.vue